<template>
  <q-layout
    ref="layout"
    view="lHh Lpr fff"
  >
    <!-- HEADER -->
    <q-layout-header>
      <q-toolbar style="height: 45px; background-color: #093370 !important;">
        <q-btn
          flat
          round
          small
          icon="fas fa-bars"
          @click="miniStateBarra = !miniStateBarra"
        >
        </q-btn>
        <img
          src="/statics/icons/icone-branco.png"
          style="width: 50px; padding: 3px; margin-left: 15px; margin-right: -5px;"
        >
        <q-toolbar-title>
          <strong class="toolbar-title">Protocolo</strong>
          <!-- <p class="q-ma-none" style="font-size: 15px" v-if="login.getCliente()">{{ login.getCliente().nomCliente }}</p> -->
           <p class="q-ma-none" style="font-size: 15px">{{ getNomeCliente() }}</p>
        </q-toolbar-title>

        <q-chip
          v-if="setQtdeNotificacao() !== 0"
          dense
          color="red-5"
          text-color="white"
          v-show='mostrarNotificacoes'
        >{{ setQtdeNotificacao() }}</q-chip>
        <q-btn-dropdown
          color="primary"
          icon="mail"
          dense
          small
          style="-webkit-box-shadow: 0 0 0 0;"
          v-show='mostrarNotificacoes'
        >
          <q-list link separator>
            <q-item
              v-for="n in arrayNotificacao"
              v-bind:key="n.a"
              @click.native="responderSolicitacao(n.protocoloSolicitacao.id, n.codNotificacaoSolicitacao)"
            >
              <!-- <q-chip
                v-if="n.indAtiva === 'N'"
                dense
                color="green-6"
                class="shadow-1"
                style="margin-right: 20px;"
              >Lido </q-chip>
              <q-chip
                v-else
                dense
                color="warning"
                class="shadow-1"
                style="margin-right: 20px;"
              >Novo</q-chip> -->
              <q-item-main style="width: 100%;">
                <q-item-tile label v-if="n.indAtiva === 'N'">{{ setDataNotificacao(n.datNotificacao) }} Solicitação Nº: {{ n.protocoloSolicitacao.numSolicitacao }}</q-item-tile>
                <q-item-tile label v-else><strong>{{ setDataNotificacao(n.datNotificacao) }} Solicitação Nº: {{ n.protocoloSolicitacao.numSolicitacao }}</strong></q-item-tile>
                <q-item-tile sublabel v-if="n.indAtiva === 'N'">Assunto: <span v-if="n.protocoloSolicitacao.subassunto">{{ n.protocoloSolicitacao.subassunto.assunto.desAssunto }}</span></q-item-tile>
                <q-item-tile sublabel v-else><strong>Assunto: <span v-if="n.protocoloSolicitacao.subassunto">{{ n.protocoloSolicitacao.subassunto.assunto.desAssunto }}</span> </strong></q-item-tile>
                <q-item-tile sublabel v-if="n.indAtiva === 'N'">SubAssunto: <span v-if="n.protocoloSolicitacao.subassunto">{{ n.protocoloSolicitacao.subassunto.desSubassunto }}</span></q-item-tile>
                <q-item-tile sublabel v-else><strong>SubAssunto: <span v-if="n.protocoloSolicitacao.subassunto">{{ n.protocoloSolicitacao.subassunto.desSubassunto }}</span></strong></q-item-tile>
                <q-item-tile sublabel v-if="n.indAtiva === 'N'">{{ n.protocoloSolicitacao.requerente.nomeDocumento }}</q-item-tile>
                <q-item-tile sublabel v-else><strong>{{ n.protocoloSolicitacao.requerente.nomeDocumento }}</strong></q-item-tile>
                <q-item-tile sublabel v-if="n.indAtiva === 'N'">{{ n.desMensagem }}</q-item-tile>
                <q-item-tile sublabel v-else><strong>{{ n.desMensagem }}</strong></q-item-tile>
              </q-item-main>
              <q-item-side
                right
                dense
                icon="fas fa-external-link-alt"
                color="blue"
              />
            </q-item>
            <q-item v-if="arrayNotificacao.length === 0">
              <q-item-side
                right
                dense
                icon="far fa-smile-beam"
                color="blue-6"
              />
              <q-item-main style="width: 100%;">
                <q-item-tile label> Nenhuma Notificação Web </q-item-tile>
              </q-item-main>
            </q-item>
          </q-list>
        </q-btn-dropdown>

        <q-item class="item-usuario">
          <!-- <q-item-side avatar>
            <img
              :src="'/statics/' + foto"
              :alt="altImage"
              class="user-card-imageRodape"
              style="background: white; border-radius: 50%; border: 1px solid white; width: 42px;"
            >
          </q-item-side> -->
          <div>
            <q-item-main>
              {{$login.getNomUsuario()}}
              <p class="adm-ano">
                {{administracaoCorrenteNome}}
                <!-- - {{anoCorrenteNome}} -->
              </p>
            </q-item-main>
          </div>
          <q-popover
            ref="refPopover"
            anchor="bottom right"
            self="top right"
            :fit="true"
            :offset="[100, -11]"
            class="shadow-2"
            id="popover"
            style="background: #093370; border-radius: 0%;"
          >
            <div @mouseenter="abrirPopover"
            >
              <q-list link class="q-pa-none lista-dropdown-popup" style="width: 200px">
                <span @click="abrirModal" class="span-aux">
                  <q-item class="item-lista-dropdown shadow-2">
                    <q-item-main>
                      <q-btn
                        @click="abrirModal"
                        small
                        round
                        flat
                        icon="fa fa-exchange-alt"
                        :disable="appCarregando"
                      >
                      </q-btn>
                      <span>Administração/Ano</span>
                    </q-item-main>
                  </q-item>
                </span>
                <span @click="(val) => home()" class="span-aux">
                  <q-item class="item-lista-dropdown shadow-2">
                    <q-item-main>
                      <q-btn
                        round
                        flat
                        icon="fa fa-home"
                        small
                        @click="home()"
                        :disable="appCarregando"
                      >
                      </q-btn>
                      <span>Home</span>
                    </q-item-main>
                  </q-item>
                </span>
                <span @click="abrirCadUnico" class="span-aux">
                  <q-item class="item-lista-dropdown shadow-2">
                    <q-item-main>
                      <q-btn
                        @click="abrirCadUnico"
                        small
                        round
                        flat
                        icon="fa fa-cogs"
                        :disable="appCarregando"
                      >
                      </q-btn>
                      <span>Sistemas</span>
                    </q-item-main>
                  </q-item>
                </span>
                <span @click="(val) => logout()" class="span-aux">
                  <q-item class="item-lista-dropdown shadow-2">
                    <q-item-main>
                      <q-btn
                        round
                        flat
                        icon="fa fa-sign-out-alt"
                        small
                        @click="logout()"
                        :disable="appCarregando"
                      >
                      </q-btn>
                      <span>Sair</span>
                    </q-item-main>
                  </q-item>
                </span>
              </q-list>
            </div>
          </q-popover>
        </q-item>
      </q-toolbar>
    </q-layout-header>

    <!-- LEFT-MENU -->
    <q-layout-drawer
      :mini="miniStateBarra && miniState"
      @mouseover="miniState = false"
      @mouseout="miniState = true"
      side="left"
      :overlay="false"
      v-model="showLeft"
      content-class="sidebar"
    >
      <div class="left-menu" style="height: 100%;">
        <q-scroll-area
          class='fit'
          style="height: 100%"
          :thumb-style="{ right: '0', borderRadius: '20px', width: '10px', height: '20px', opacity: 0.4}"
        >

          <!-- RODAPE -->
          <div
            :class="'text-center' + ' fixed-bottom-rodape shadow-up-10'"
            style="background: rgb(9, 51, 112) !important"
          >
            <a
              href="http://publicenter.com.br"
              target="_blank"
            >
              <img
                v-if="miniState && miniStateBarra"
                :src="`statics/${logoEmpresa}LogoTipo.png`"
                alt="publicenter.com.br"
                class="user-card-imageRodape"
                style="height: 35px!important; width:auto;"
              >
              <img
                v-else
                :src="`statics/${logoEmpresa}LogoMarca.png`"
                alt="publicenter.com.br"
                style="height: 42px;
                  width: auto;
                  margin: 2px 2px -8px 7px;"
              >
            </a>
            <p class="versao" @click="redirecionarTelaVersoes">
              {{versao}}
              <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                <strong>Histórico de versões</strong>
              </q-tooltip>
            </p>
          </div>

          <!-- PESQUISA -->
          <q-item v-ripple class="shadow-2">
            <q-icon class="icone-sidebar"
              name="fas fa-search"
              for="pesquisaMenu"
              size="18px"
            />
            <q-item-main>
              <q-input
                v-model="termoPesquisa"
                class="q-ml-md"
                placeholder="Pesquisa de menus"
                @input="filtrarMenus"
                id="pesquisaMenu"
                name="pesquisaMenu"
                color="white"
              />
            </q-item-main>
          </q-item>

          <!--PRINCIPAL Array dos Pais-->
          <div
            v-for="n0 in permissoesArrayPai"
            v-bind:key="n0.p"
          >
            <!----------CASO O MENU TENHA LINK------------------------------------>
            <q-item
              v-if="verificarLink(n0.desPaginaPrincipal)"
              :to="n0.desPaginaPrincipal"
              :icon="n0.desIconeModulo"
            >
              <q-icon
                class="icone-sidebar"
                :name="n0.desIconeModulo"
                size="20px"
              />
              <q-item-main
                class="q-pl-md"
                color="white"
                :label="n0.nomModulo"
                :id="n0.nomModulo.replace(/\s{1,}/g, '')"
                :name="n0.nomModulo.replace(/\s{1,}/g, '')"
                style="color: white;"
              />
            </q-item>
            <!----------SE NÃO TIVER LINK------------------------------------>
            <q-collapsible
              v-if="!verificarLink(n0.desPaginaPrincipal)"
              group="grupo1"
              :label="n0.nomModulo"
              class="gvn-collapse shadow-2"
              :disable="appCarregando"
              :ref="'ref' + n0.codModulo"
            >
              <template slot="header">
                <q-icon class="icone-sidebar" :name="n0.desIconeModulo" size="20px"/>
                <q-item-main
                  class="q-pl-md"
                  :label="n0.nomModulo"
                  :id="n0.nomModulo.replace(/\s{1,}/g, '')"
                  :name="n0.nomModulo.replace(/\s{1,}/g, '')"
                />
              </template>
              <!-------------BUSCA OS MÓDULOS DE ACORDO COM O CÓDIGO DO MODULO ACIMA------------------------>
              <div
                v-for="n1 in permissoesArray.filter(v => v.codModuloPai === n0.codModulo)"
                v-bind:key="n1.f"
              >
                <!----------CASO O MENU TENHA LINK------------------------------------>
                <div class="q-pl-xl">
                  <q-item
                    v-if="verificarLink(n1.desPaginaPrincipal)"
                    :to="n1.desPaginaPrincipal"
                  >
                    <template slot="header">
                      <q-item-main
                        :label="n1.nomModulo"
                        :id="n1.nomModulo.replace(/\s{1,}/g, '')"
                        :name="n1.nomModulo.replace(/\s{1,}/g, '')"
                      />
                    </template>
                    <q-item-main
                      color="white"
                      :label="n1.nomModulo"
                      :id="n1.nomModulo.replace(/\s{1,}/g, '')"
                      :name="n1.nomModulo.replace(/\s{1,}/g, '')"
                    />
                  </q-item>
                  <!--SENÃO-->
                  <q-collapsible
                    v-if="!verificarLink(n1.desPaginaPrincipal)"
                    group="grupo2"
                    :label="n1.nomModulo"
                    class="gvn-collapse "
                    :disable="appCarregando"
                  >
                    <template slot="header">
                      <q-item-main
                        :label="n1.nomModulo"
                        :id="n1.nomModulo.replace(/\s{1,}/g, '')"
                        :name="n1.nomModulo.replace(/\s{1,}/g, '')"
                      />
                    </template>
                    <!------------------------------------------------------------------------------------------------>
                    <div
                      v-for="n2 in permissoesArray.filter(v => v.codModuloPai === n1.codModulo)"
                      v-bind:key="n2.f"
                    >
                      <div class="q-ml-lg">
                        <!--q-item to="/privado/responsavelSetor/pesquisa">-->
                        <q-item
                          v-if="verificarLink(n2.desPaginaPrincipal)"
                          :to="n2.desPaginaPrincipal"
                        >
                          <q-item-main
                            color="white"
                            :label="n2.nomModulo"
                            :id="n2.nomModulo.replace(/\s{1,}/g, '')"
                            :name="n2.nomModulo.replace(/\s{1,}/g, '')"
                          />
                        </q-item>
                      </div>
                    </div>
                  </q-collapsible>
                </div>
              </div>
            </q-collapsible>
          </div>
        </q-scroll-area>
      </div>
    </q-layout-drawer>

    <!-- REQUIRED -->
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { login } from '../../plugins/login'
import utilHttp from 'components/util/utilHttp'
import api from 'components/util/api'
import util from 'components/util/util'
import GSelect from 'components/util/gSelect'
import GLayoutHeader from 'components/util/gLayoutHeader'
// import  * as types from 'store/sessao/mutation-types'

export default {
  data () {
    return {
      usuario: '',
      foto: 'avatar.png',
      altImage: '',
      miniState: true,
      miniStateBarra: true,
      termoPesquisa: '',
      anoArray: [],
      permissoesArray: [],
      permissoesArrayPai: [],
      permissoesArrayFilho: [],
      administracaoArray: [],
      mostrarNotificacoes: false,
      sessao: {
        codAdm: '',
        codAno: ''
      },
      modalAberto: false,
      appCarregando: false,
      progresso: false,
      versao: null,
      showLeft: true,
      myWorker: null,
      logoEmpresa: null,

      apiNotificacaoLida: api.NOTIFICACAO_SOLICITACAO_USUARIO_MARCAR_COMO_LIDA,
      apiNotificacaoUsuario: api.NOTIFICACAO_SOLICITACAO_USUARIO,
      apiNotificacao: api.NOTIFICACAO_SOLICITACAO,
      arrayNotificacao: []
    }
  },
  methods: {
    getNomeCliente () {
      return this.$login.getCliente() !== null ? this.$login.getCliente().nomCliente : ''
    },
    filtrarMenus (val) {
      // let aberto = null

      // this.menusShow = this.menus.filter((menu) => {
      //   const autoMatch = menu.label.toUpperCase().indexOf(val.toUpperCase()) !== -1

      //   const submenus = menu.submenus.filter((submenu) => {
      //     return submenu.label.toUpperCase().indexOf(val.toUpperCase()) !== -1
      //   })
      //   if (submenus.length > 0) {
      //     if (!aberto) aberto = menu.id
      //     return true
      //   }
      //   return autoMatch
      // })

      // this.menusShow.forEach((menu) => {
      //   menu.submenusShow = menu.submenus.filter((submenu) => {
      //     return submenu.label.toUpperCase().indexOf(val.toUpperCase()) !== -1
      //   })
      // })

      // if (aberto) {
      //   this.menusShow = this.menusShow.map((menu) => {
      //     if (menu.id === aberto) return { ...menu, aberto: true }
      //     else return menu
      //   })
      //   if (this.$refs['ref' + aberto][0]) this.$refs['ref' + aberto][0].show()
      // }
    },
    abrirModal () {
      this.modalAberto = true
    },
    abrirModalMudarAvatar () {
      this.modalAvatar = true
    },
    abrirPopover (evt) {
      this.$refs['refPopover'].show()
    },
    fecharPopover (evt) {
      this.$refs['refPopover'].hide()
    },
    home () {
      this.$router.push({ name: 'index' })
    },
    logout () {
      this.$q.dialog({
        title: 'SAINDO',
        message: 'Deseja realmente sair do sistema?',
        cancel: true
      }).then(() => {
        // Picked "OK"
        login.sair()
      }).catch(() => {
        // Picked "Cancel" or dismissed
      })
    },
    abrirCadUnico () {
      this.$login.abrirCadUnico()
    },
    verificarLink (link) {
      if (link === '') {
        return false
      }
      if (link === null) {
        return false
      }
      return true
    },
    montarArrayFilho (codModuloPai) {
      var self = this
      self.permissoesArrayFilho = self.permissoesArray.filter(p => p['codModuloPai'] === codModuloPai)
      return self.permissoesArrayFilho
    },
    carregarSelectAnoExercicio () {
      this.progresso = true
      var anoAtual = new Date().getFullYear()
      utilHttp.httpGet(api.ANO_INICIO, (resposta) => {
        var anoIncio = resposta.body
        var i
        this.anoArray = []
        for (i = anoAtual; i >= anoIncio; i--) {
          this.anoArray.push({ codAno: i.toString() })
        }
        this.sessao.codAno = anoAtual.toString()
        this.progresso = false
      })
    },
    carregarSelectAdministracao () {
      this.administracaoArray = []
      utilHttp.httpGet(api.ADMINISTRACAO, (resposta) => {
        this.administracaoArray = resposta.body
        this.progresso = false
      })
    },
    redirecionarTelaVersoes () {
      this.$router.push({ name: 'versoes' })
    },

    setDataNotificacao (datNotificacao) {
      let data = util.formatarDiaMesAno(datNotificacao)
      let hora = util.formatarHoraMinuto(datNotificacao)
      return data.concat(' às ').concat(hora)
    },
    responderSolicitacao (codSolicitacao, codNotificacaoSolicitacao) {
      var self = this
      let url = api.BUSCAR_PROTOCOLO_SOLICITACAO_MOVIMENTACAO_PELO_COD_SOLICITACAO
      url = url.concat('?codSolicitacao=').concat(codSolicitacao)
      url = url.concat('&status=').concat('PAS')
      utilHttp.httpGet(url, resposta => {
        let paginaStatus = {
          aberturaProcesso: {
            formaSolicitacao: {},
            tipoProcesso: {},
            subassunto: {
              assunto: {}
            },
            roteiro: {
              setor: {
                unidade: {
                  orgao: {}
                }
              }
            },
            requerente: {},
            representante: {},
            justificativa: {},
            responsavel: { usuario: {} },
            documentoNecessario: {},
            aberturaProcessoDocumento: {}
          }
        }
        paginaStatus.protocoloSolicitacaoMovimentacao = resposta.body[0]
        paginaStatus.desabilitarEdicao = false
        paginaStatus.operacao = {
          descricao: 'Gerenciar Solicitação de Abertura',
          icone: 'fas fa-reply'
        }
        paginaStatus.caminhoMigalha = []
        paginaStatus.caminhoMigalha.push(
          {
            icone: 'fas fa-folder-open',
            descricao: 'Gestão de Solicitação de Abertura',
            rotaNome: 'solicitacaoAberturaPesquisa'
          }
        )
        self.marcarNotificacaoComoLida(paginaStatus.protocoloSolicitacaoMovimentacao.protocoloSolicitacao.id, codNotificacaoSolicitacao)
        self.$router.push({
          name: 'solicitacaoAbertura',
          params: {
            paginaStatus: paginaStatus
          }
        })
        // window.open('/#/privado/gestaoSolicitacaoAbertura/cadastrar')
        // self.$router.go({name: 'solicitacaoAbertura'})
      })
    },
    setCorMensagemNotificacao (mensagem) {
      if (mensagem.toString().includes('Nova')) {
        return 'green'
      } else {
        return 'orange'
      }
    },
    setQtdeNotificacao () {
      let qtde = 0
      this.arrayNotificacao.forEach(n => {
        if (n.indAtiva === 'S') {
          qtde = qtde + 1
        }
      })
      return qtde
    },
    verificarSolicitacaoWeb () {
      let url = api.BUSCAR_TODAS_NOTIFICACAO_SOLICITACAO
      url = url.concat('?codUsuario=').concat(this.$login.getCodUsuario())
      utilHttp.httpGet(url, resposta => {
        this.arrayNotificacao = resposta.body
      })
      // setTimeout(() => this.verificarSolicitacaoWeb(), 100000)
    },
    marcarNotificacaoComoLida (codProtocoloSolicitacao, codNotificacaoSolicitacao) {
      let url = this.apiNotificacaoLida
      url = url.concat('?codProtocoloSolicitacao=').concat(codProtocoloSolicitacao)
      url = url.concat('&codUsuario=').concat(this.$login.getCodUsuario())
      utilHttp.httpGet(url, resposta => {
        this.verificarSolicitacaoWeb()
      })
      utilHttp.httpDeletePorID(`${this.apiNotificacao}/${codNotificacaoSolicitacao}`, (resposta) => {
        // console.log('Notificação excluida')
      })
    }
  },
  computed: {
    administracaoCorrenteNome () {
      let adm = this.$store.state.sessao.administracao
      return adm ? adm.desadm : null
    },
    anoCorrenteNome () {
      let ano = this.$store.state.sessao.ano
      return ano
    }
  },
  mounted () {
    utilHttp.httpGet(api.VERSAO, (resposta) => {
      this.versao = resposta.bodyText
    })

    var self = this
    self.verificarSolicitacaoWeb()
    setTimeout(() => {
      if (!this.$login.getJwtAccess()) {
        util.exibirToastFalha('Usuário ' + this.$login.getDesLogin() + ' NÃO possui perfil de acesso!')
        login.sair()
        self.$router.push('/')
      } else {
        let permissoes = this.$login.getPermissoes()
        self.permissoesArray = permissoes
        if (permissoes) {
          self.permissoesArrayPai = permissoes.filter(p => p['codModuloPai'] === undefined)

          this.mostrarNotificacoes = self.permissoesArray.filter(
            (permissao) => permissao.desPaginaPrincipal === '/privado/gestaoSolicitacaoAbertura/pesquisa').length > 0
        }
      }
    }, 100)

    utilHttp.httpGet(api.LOGO_EMPRESA, (resposta) => {
      this.logoEmpresa = resposta.bodyText
    })
  },
  components: { GSelect, GLayoutHeader }
}
</script>

<style scope lang='styl'>
@import "~variables";
.user-card {
  background: #e7ecf2;
  color: #4f6984;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 0;
}

div.scroll.relative-position.overflow-hidden.fit div.absolute.full-width {
  height: 100%;
}

.sidebar {
  background-color: #093370;
}

.icone-sidebar {
  width: 20px;
  /* color: #093370; */
  color: white;
  font-size: 25px;
}

.user-card-main > div {
  margin: 0 3px;
}

.user-card-image {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background: #f9b357;
  margin: 10px 10px 10px 0;
}

.user-card-imageRodape {
  width: 38px;
  height: auto;
  margin: 6px 10px 2px 10px;
}

.user-card-title {
  font-size: 20px;
  word-break: break;
}

.user-card-subtitle {
  font-size: 9px;
}

.user-card-details {
  background-color: #fff;
}

.gvn-user-menu .q-item-icon {
  color: #fff;
}

.gvn-supermenu {
  font-size: 13px;
  font-weight: 500;
  padding: 0 !important;
  min-height: 30px !important;
  text-align: left;
}

.q-collapsible-sub-item {
  padding: 5px;
}

.selecao-avatar {
  width: 80%;
  background:#093370;
  border-radius: 50%;
  cursor: pointer;
  transition: .5s;
}

.selecao-avatar:hover {
  box-shadow: 0 0 15px #F59425 ;
}

.gvn-user-menu {
  background-color: #263238;
}

.gvn-user-menu .q-item-label {
  text-align: center;
  color: #fff;
  font-size: 18px;
}

.gvn-user-menu .q-collapsible-sub-item {
  padding: 0;
}

.gvn-user-menu > div > img {
  min-width: 30px !important;
  width: 48px !important;
}

.gvn-user-menu-container {
  background: white;
  padding: 0;
}

.left-menu {
  position: absolute;
  right: 0;
  bottom: 23px;
  left: 0;
  top: 0;
}
.gvn-menu-item {
  padding: 0;
}

.span-aux {
  cursor: pointer;
}

.gvn-menu-item:hover {
  background-color: #8d8d8d;
}

.gvn-user-menu .gvn-menu-item {
  background-color: #9d9d9d;
  font-size: 16px;
}

.gvn-user-menu .gvn-menu-item .q-item-sublabel {
  color: #0c0c0c;
}

/* GAMBIARRA, PARA MUDAR A COR DO ICONE DO COLAPSE (NÃO ME MATE, PF) */
/* .gvn-collapse .q-icon {
  color: white;
} */

.botao-usuario {
  color: white;
  background: #093370;
}

#pesquisaMenu {
  color: white;
}

#pesquisaMenu::placeholder {
  color: #f5f5f5!important;
}

.gvn-collapse {
  color: white;
}

.item-lista-dropdown {
  padding: 2px 6px;
  font-size: 14px;
}

.item-lista-dropdown:hover {
  background: #314164;
}

#popover {
  left: unset !important;
  right: 0;
}

.lista-dropdown {
  color: #093370;
  font-size: 12px;
}

.lista-dropdown-popup {
  color: white;
  font-size: 12px;
  border: 1px solid #093370;
}

button.q-btn.inline.relative-position.q-btn-item.non-selectable.q-btn-round.q-btn-flat.q-focusable.q-hoverable.q-btn-dropdown.q-btn-dropdown-simple.cursor-pointer div.q-btn-inner.row.col.items-center.q-popup--skip.justify-center i.q-icon.transition-generic.material-icons.on-right.q-btn-dropdown-arrow {
  display: none;
}

.adm-ano {
  margin: 0;
  color: #e5e5e5;
  font-size: 12px;
}

.versao {
  font-size: 10px;
  text-align: center;
  margin: 2px 4px;
  color: white;
  font-style: italic;
  cursor: pointer;
}

.gvn-collapse .pad-l-60 {
  padding-left: 60px !important;
}

.gvn-collapse .pad-l-60:hover {
  border-left: 4px solid white !important;
  background-color: rgba(189,189,189,0.4);
  color: white;
}

.gvn-collapse .pad-l-60:active {
  background-color: rgba(189,189,189,0.4);
}

.gvn-menu-item:hover {
  background: #465c74;
  border-left: 5px solid #71b0d3;
}

.gvn-menu-item.router-link-exact-active {
  background: #465c74 !important;
  border-left: 5px solid #71b0d3 !important;
}

.q-collapsible-sub-item {
  padding: 0 !important;
}

.layout-page {
  min-height: calc(100vh - 58px) !important;
}

.mensagem-cabecalho {
  background-color: #e6e6e6;
  margin-right: -16px !important;
  margin-left: -16px !important;
  padding-left: 16px !important;
}

.fixed-bottom-rodape {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #465c74;
  z-index: 3000;
}

.icone-menu-suspenso {
  align-self: center;
  margin-right: 10px;
}
</style>
